import { Routes } from '@angular/router';

export const content: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../../components/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'productos',
    loadChildren: () => import('../../components/productos/producto.module').then(m => m.ProductoModule)
  },
  {
    path: 'Comprobantes',
    loadChildren: () => import('../../components/comprobantes/comprobante.module').then(m => m.ComprobanteModule)
  },
  {
    path: 'cuenta-corriente',
    loadChildren: () => import('../../components/cuenta_corriente/ctacte.module').then(m => m.CtacteModule)
  },
  // {
  //   path: 'descuentos',
  //   loadChildren: () => import('../../components/descuentos/descuentos.module').then(m => m.DescuentosModule)
  // },
  {
    path: 'ordenes-entrega',
    loadChildren: () => import('../../components/ordenes_entrega/ordenes_entrega.module').then(m => m.OrdenEntregaModule)
  },
  // {
  //   path: 'descuentos',
  //   loadChildren: () => import('../../components/descuentos/descuentos.module').then(m => m.DescuentosModule)
  // },
  {
    path: 'mi-carrito',
    loadChildren: () => import('../../components/mi_carrito/cart.module').then(m => m.CartModule)
  },
  {
    path: 'ofertas-novedades',
    loadChildren: () => import('../../components/ofertas_novedades/ofertas-novedades.module').then(m => m.OfertasNovedadesModule)
  },
  {
    path: 'cuenta-usuario',
    loadChildren: () => import('../../components/mi_cuenta/mi-cuenta.module').then(m => m.MiCuentaModule)
  },
  // SC CATFER-17 se agrega a las rutas el acceso al nuevo modulo de pendiente despacho
  {
    path: 'pendiente-despacho',
    loadChildren: () => import('../../components/pendiente-despacho/pendiente-despacho.module').then(m => m.PendienteDespachoModule) 
  },
  {
    path: 'download',
    loadChildren: () => import('../../components/download/download.module').then(m => m.DownloadModule) 
  },
  // {
  //   path: 'config-cliente',
  //   loadChildren: () => import('../../components/config_cliente/config-cliente.module').then(m => m.ConfigClienteModule) 
  // },
  // {
  //   path: 'margenes',
  //   loadChildren: () => import('../../components/margenes/margenes.module').then(m => m.MargenesModule) 
  // },
  // {
  //   path: 'gestion-usuarios',
  //   loadChildren: () => import('../../components/gestion-usuarios/gestion-usuarios.module').then(m => m.GestionUsuariosModule) 
  // },

];
